import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  calcResults: {
    reqSnowBrktPerSqrArg: '',
    actualSnowBracketPerSquare: '',
    horizontalEaveSpacing: '',
    horizontalFieldSpacing: '',
    verticalSpacing: '',
    numOfCoursesHorizontalAtEave: '',
    numOfCoursesVertically: '',
    totalBracketsForRoofingSquares: ''
  }
};

const calculationsSilce = createSlice({
  name: 'calculations',
  initialState: initialState,
  reducers: {
    setCaclulcationResults: (state, action) => {
      state.calcResults = action.payload;
    },
    setAllOutputs: (state, action) => {
      const outputData = action.payload.outputData;
      state.calcResults = {
        reqSnowBrktPerSqrArg: outputData.requiredSnowBracketsPerSquare,
        actualSnowBracketPerSquare: outputData.calculatedSnowBracketsPerSquare,
        horizontalEaveSpacing: outputData.horizontalEaveSpacing,
        horizontalFieldSpacing: outputData.horizontalFieldSpacing,
        verticalSpacing: outputData.verticalSpacing,
        numOfCoursesHorizontalAtEave: outputData.numberOfCoursesHorizontally,
        numOfCoursesVertically: outputData.numberOfCoursesVertically,
        totalBracketsForRoofingSquares: outputData.totalBracketsForRoofingSquares
      };
    },
    clearCalculationsData: (_) => initialState
  }
});

export const { setCaclulcationResults, setAllOutputs, clearCalculationsData } =
  calculationsSilce.actions;
export default calculationsSilce.reducer;
